"use strict";function nfcWrite$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.nfcWrite$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.nfc.nfcWrite";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.11.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.11.0"},_a)),exports.nfcWrite$=nfcWrite$,exports.default=nfcWrite$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/nfc/nfcWrite.js
// module id = 1066
// module chunks = 106